import React from "react";
import Grid from "@material-ui/core/Grid";

import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import NumberFormat from "react-number-format";
import InstitutionDropDown from "../../components/dropDown/institution";
import RentTypeDropDownContainer from "../../components/dropDown/rentType";
import SpecialFlowDropDown from "../../components/dropDown/specialFlow";
import {InputText} from "primereact/inputtext";
import HeaderScreenPresval from "../../components/headerScreenPresval";
import ContextMenu from "../../components/contextMenu";
import Typography from "@material-ui/core/Typography";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";
import {Calendar} from "primereact/calendar";
import {CALENDAR_ES, DATE_FORMAT_CALENDAR} from "../../utils/constants/Constants";
import {getIconFromMenu} from "../../utils/icon/IconProcessor"

const ControlPanel = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '0%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                {props.anticipatedMaturityConfMsg}
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <HeaderScreenPresval headerTitle="Tablero de Control"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.getControlPanelLoan}
                                             menuIcon={getIconFromMenu("Tablero de control ")}
                        >
                            <div className="p-grid">
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Folio" isBold={true}/>
                                    <NumberFormat
                                        name="loanIdFilter"
                                        allowNegative={false}
                                        maxLength={9}
                                        thousandSeparator={false}
                                        onChange={props.saveFilters}
                                        value={props.loanIdFilter}
                                        customInput={InputText}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Prestamista" isBold={true}/>
                                    <InstitutionDropDown
                                        name="catInstitutionLenderFilter"
                                        filter="nombreCorto"
                                        save={props.saveFilters}
                                        value={props.catInstitutionLenderFilter}
                                        loading={props.loading}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Prestatario" isBold={true}/>
                                    <InstitutionDropDown
                                        name="catInstitutionBorrowerFilter"
                                        filter="nombreCorto"
                                        save={props.saveFilters}
                                        value={props.catInstitutionBorrowerFilter}
                                        loading={props.loading}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Tipo de renta" isBold={true}/>
                                    <RentTypeDropDownContainer
                                        name="catRentTypeFilter"
                                        filter="descripcionId"
                                        save={props.saveFilters}
                                        value={props.catRentTypeFilter}
                                        loading={props.loading}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Flujo" isBold={true}/>
                                    <SpecialFlowDropDown
                                        name="catFlowFilter"
                                        filter="descripcionId"
                                        save={props.saveFilters}
                                        value={props.catFlowFilter}
                                        loading={props.loading}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Fecha Inicio" isBold={true}/>
                                    <Calendar name="concertDate"
                                              locale={CALENDAR_ES}
                                              dateFormat={DATE_FORMAT_CALENDAR}
                                              disabledDays={[0, 6]}
                                              readOnlyInput={true}
                                              value={props.concertDate}
                                              onChange={props.saveFilters}
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange={CALENDAR_ES['yearRangeFuture']}
                                              showButtonBar={true}
                                    />
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Fecha Vencimiento" isBold={true}/>
                                    <Calendar name="maturityDate"
                                              locale={CALENDAR_ES}
                                              dateFormat={DATE_FORMAT_CALENDAR}
                                              disabledDays={[0, 6]}
                                              readOnlyInput={true}
                                              value={props.maturityDate}
                                              onChange={props.saveFilters}
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange={CALENDAR_ES['yearRangeFuture']}
                                              showButtonBar={true}
                                    />
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <br/>
                                    <Button
                                        style={{'float': 'right'}}
                                        label="Limpiar"
                                        className="p-button-secondary"
                                        onClick={props.clearFilters}/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>
                    <Grid item xs={12} style={{textAlign: 'right'}}>
                        { props.isAdminUser &&
                            <span style={{fontSize: '80%'}}>Total de vencimientos:&nbsp;{props.totalExpiredLoad}&nbsp;&nbsp;</span>
                        }
                        <Typography variant="subtitle2" className={"secondary-text"}>
                            Vigentes:&nbsp;
                            <ContextMenu menuOptions={props.exportOptionsVig}
                                         isButton={true}
                                         label="Exportar"/>&nbsp;&nbsp;
                            Vencidos:&nbsp;
                            <ContextMenu menuOptions={props.exportOptionsVen}
                                         isButton={true}
                                         label="Exportar"/>
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            ref={props.controlPanelTable}
                            selectionMode="single"
                            responsive={true}
                            value={props.loanControlPanel}
                            selection={props.selectedControlPanel}
                            onSelectionChange={props.selectRowControlPanel}
                            onRowDoubleClick={props.onRowDoubleClickControlPanel}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column header=""
                                    body={props.controlPanelTemplate}
                                    style={{textAlign: 'left', width: '3%'}}/>
                            <Column field="idFolioPrest" header="Folio"
                                    style={{textAlign: 'left', width: '5%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                            <Column field="flujo" header="Flujo"
                                    style={{textAlign: 'left', width: '6%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                            <Column field="statusPV" header="Estatus"
                                    style={{textAlign: 'left', width: '5%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                            <Column field="emisora" header="Emisora"
                                    style={{textAlign: 'left', width: '10.5%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                            <Column field="cantPrestamo" header="Títulos"
                                    style={{textAlign: 'right', width: '6.5%'}}
                                    body={props.boldAndColorNumberTemplate} sortable={true}/>
                            <Column field="precio" header="Precio"
                                    style={{textAlign: 'right', width: '8%'}}
                                    body={props.boldAndColorPriceTemplate} sortable={true}/>
                            <Column field="importe" header="Importe"
                                    style={{textAlign: 'right', width: '10%'}}
                                    body={props.boldAndColorAmountTemplate} sortable={true}/>
                            <Column field="plazo" header="Plazo"
                                    style={{textAlign: 'right', width: '4%'}}
                                    body={props.boldAndColorNumberTemplate} sortable={true}/>
                            <Column field="tasa" header="Tasa"
                                    style={{textAlign: 'right', width: '4%'}}
                                    body={props.boldAndColorRateTemplate} sortable={true}/>
                            <Column field="premio" header="Premio"
                                    style={{textAlign: 'right', width: '7.5%'}}
                                    body={props.boldAndColorAmountTemplate} sortable={true}/>
                            <Column field="nomCortoPTM" header="Prestamista"
                                    style={{textAlign: 'left', width: '9%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                            <Column field="cuentaPTM" header="Cta Ptm"
                                    style={{textAlign: 'left', width: '7%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                            <Column field="nomCortoPTT" header="Prestatario"
                                    style={{textAlign: 'left', width: '9%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                            <Column field="sistema" header="Sistema"
                                    style={{textAlign: 'left', width: '5.5%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default ControlPanel;